import React, { Component } from "react";
import Header from "./header";
import jwt_decode from "jwt-decode";

class DashBoard extends Component {
  state = {
    isPrivilegedUser: 0
  };

  componentDidMount() {
    this.getUserLogged();
  }

  getUserLogged = () => {
    if (localStorage.getItem("token") !== null) {
      const userToken = JSON.parse(localStorage.getItem("token").toString());
      let decoded = jwt_decode(userToken.token);
      if (decoded.malote_escrever === 1) this.setState({ isPrivilegedUser: 1 });
      else this.setState({ isPrivilegedUser: 0 });
    }
  };

  render() {
    return (
      <React.Fragment>
        <Header title={"Painel"} activeNavContent={true} />
        <div
          className="body-content"
          style={{
            width: "100%",
            float: "center",
            marginTop: "30px",
            fontSize: "1.2rem"
          }}
        >
          <div className="section-dashboard ">
            <div className="container">
              <div className="box-content">
                <div
                  className="row justify-content-center"
                  style={{ marginTop: "25px" }}
                >
                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-content white-text">
                        <span className="card-title">Gerência</span>
                      </div>
                      <div className="card-content white-text">
                        Interceptação e mudança de <i>status</i> dos itens
                        referentes a cada malote.
                      </div>
                      <div className="card-action">
                        <a href="/validacao">Acesse Aqui</a>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-content white-text">
                        <span className="card-title">Cadastro</span>
                      </div>
                      <div className="card-content white-text">
                        Envio de novo malote e registro de novas(os)
                        movimentações/itens.
                      </div>
                      <div className="card-action">
                        <a
                          href={
                            this.state.isPrivilegedUser === 1
                              ? "/cadastro"
                              : "/painel"
                          }
                          style={
                            this.state.isPrivilegedUser === 1
                              ? {
                                  color: "#ffab40",
                                  marginRight: "24px",
                                  WebkitTransition: "color .3s ease",
                                  transition: "color .3s ease",
                                  textTransform: "uppercase"
                                }
                              : {
                                  color: "white",
                                  cursor: "not-allowed",
                                  opacity: "0.5",
                                  textDecoration: "none"
                                }
                          }
                        >
                          Acesse Aqui
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-content white-text">
                        <span className="card-title">Consulta - Malotes</span>
                      </div>
                      <div className="card-content white-text">
                        Visualização das movimentações e itens referentes a cada
                        malote.
                      </div>
                      <div className="card-action ">
                        <a
                          href={
                            this.state.isPrivilegedUser === 1
                              ? "/consulta_malotes"
                              : "/painel"
                          }
                          style={
                            this.state.isPrivilegedUser === 1
                              ? {
                                  color: "#ffab40",
                                  marginRight: "24px",
                                  WebkitTransition: "color .3s ease",
                                  transition: "color .3s ease",
                                  textTransform: "uppercase"
                                }
                              : {
                                  color: "white",
                                  cursor: "not-allowed",
                                  opacity: "0.5",
                                  textDecoration: "none"
                                }
                          }
                        >
                          Acesse Aqui
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-content white-text">
                        <span className="card-title">Consulta - Itens</span>
                      </div>
                      <div className="card-content white-text">
                        Visualização de todos os malotes, movimentações e itens.
                      </div>
                      <div className="card-action ">
                        <a
                          href={
                            this.state.isPrivilegedUser === 1
                              ? "/consulta_itens"
                              : "/painel"
                          }
                          style={
                            this.state.isPrivilegedUser === 1
                              ? {
                                  color: "#ffab40",
                                  marginRight: "24px",
                                  WebkitTransition: "color .3s ease",
                                  transition: "color .3s ease",
                                  textTransform: "uppercase"
                                }
                              : {
                                  color: "white",
                                  cursor: "not-allowed",
                                  opacity: "0.5",
                                  textDecoration: "none"
                                }
                          }
                        >
                          Acesse Aqui
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default DashBoard;
